import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e3e1d0be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ConfigRecommendGoods home-module-bg guideDom-channel-all-4" }
const _hoisted_2 = { class: "ConfigRecommendGoods-header" }
const _hoisted_3 = { class: "ConfigRecommendGoods-list" }
const _hoisted_4 = { class: "ConfigRecommendGoods-page" }

import { onMounted, reactive, watch } from 'vue'
import { t } from '@/plugins/i18n'
import { useRequest } from '@/util/useLoading'
import PaginationArrow from '@/components/common/PaginationArrow.vue'
import GoodsItem from '@/components/common/GoodsItem.vue'
import { getConfigRecommendGoods } from '@/apis/goods'
import bus from '@/util/useBus'
import { useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stationCode = useSite2Station()

onMounted(() => {
  getList()
})

bus.on('guide', (state: any) => {
  if (state.key === 'guide-channel-ConfigRecommendGoods-virtual') {
    for (const key in state.data) {
      if (Object.prototype.hasOwnProperty.call(state.data, key)) {
        const element = state.data[key]
        data[key] = element
      }
    }
  }
  if (state.key === 'guide-channel-ConfigRecommendGoods-recovery') {
    for (const key in state.data) {
      if (Object.prototype.hasOwnProperty.call(state.data, key)) {
        const element = state.data[key]
        data[key] = element
      }
    }
    getList()
  }
})

const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 15,
    total: 0,
    pages: 1
  }
})

// 获取列表
const [loading, getList] = useRequest(() => {
  const formData = {
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize,
    stationCode
  }
  return getConfigRecommendGoods(formData).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data.records
      data.page.total = res.data.total
      data.page.pages = res.data.pages
    }
  })
})

// 分页切换
const pageChange = (page: number) => {
  data.page.currentPage = page
  getList()
}

// item不喜欢操作回调
const itemUnlike = (productCode: string) => {
  const index = data.list.findIndex((item: any) => item.productCode === productCode)
  data.list.splice(index, 1)
}


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('担当推荐商品')), 1),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
        return (_openBlock(), _createBlock(GoodsItem, {
          key: item.productCode,
          item: item,
          showChannel: 8,
          onUnlike: itemUnlike
        }, null, 8, ["item"]))
      }), 128))
    ], 512), [
      [_directive_loading, _unref(loading)]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(PaginationArrow, {
        currentPage: _unref(data).page.currentPage,
        pages: _unref(data).page.pages,
        "onUpdate:currentPage": pageChange
      }, null, 8, ["currentPage", "pages"])
    ])
  ], 512)), [
    [_vShow, _unref(data).list.length !== 0]
  ])
}
}

})